module.exports = __webpack_public_path__ + "img/12.bb3acbea.svg";